import React, { useState } from "react";
import "./slider.css";
import { useTranslation } from "react-i18next";

const LanguageSelector = ({ color = "" }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    setLanguage(selectedLanguage);
  };

  return (
    <div className="flex gap-2 items-center">
      <label className="switch">
        <input
          type="checkbox"
          value="en"
          checked={language === "en"}
          onChange={handleLanguageChange}
        />
        <span
          className={`${
            color ? "sliderYellow slider" : "slider"
          } round enslider`}
        />
      </label>
      <label className="switch">
        <input
          type="checkbox"
          value="es"
          checked={language === "es"}
          onChange={handleLanguageChange}
        />
        <span
          className={`${
            color ? "sliderYellow slider" : "slider"
          } round esslider`}
        />
      </label>
    </div>
  );
};

export default LanguageSelector;
